"use strict";
import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

export default class InfoModal extends React.PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        closeText: PropTypes.string,
        title: PropTypes.string
    };

    static defaultProps = {
        closeText: 'Cancel',
        title: 'Information'
    };

    render() {
        const { children, closeText, title } = this.props;

        return (
            <Modal show={true} onHide={this.handleClose} className="modalComponent">
                <Modal.Header closeButton={true}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{children}</Modal.Body>
                <Modal.Footer>
                    <a className="btn btn-cancel" onClick={this.handleClose}>
                        {closeText}
                    </a>
                </Modal.Footer>
            </Modal>
        );
    }

    handleClose = () => {
        const { onClose } = this.props;

        if (onClose) {
            onClose();
        }
    }
}
